import { FlexContainer, Hr, Img } from "../../../design";
import Logo from "../../../assets/imgs/swirepay-logo.svg";
import React from "react";
import SmallScreenView from "../index";

type Props = {
  children: Node
}

const SmallScreenHeader = (props: Props) => {
  const { children, paymentCheckout, bankImageUrl, largeLogo } = props;
  return (
    <SmallScreenView>
      {
        !paymentCheckout && (
          <FlexContainer paddingTop="10px" paddingBottom="20px" justifyContent="center" alignContent="center" >
            <Img src={Logo} width="180" />
          </FlexContainer>
        )
      }

      {
        paymentCheckout && (
          <>
          <FlexContainer paddingTop="10px" paddingBottom="-10px">
            <Img width="180" src={largeLogo || bankImageUrl} />
          </FlexContainer>
          </>
        )
      }
      <div className="px-1 px-md-4 mt-2">
        {children}
      </div>
      <Hr marginTop="0px" />
    </SmallScreenView>
  )
};

export default SmallScreenHeader;
